import React from 'react';
import useInView from '../hooks/useInView';

/**
 * Adds the `is-visible` class when the element enters the viewport. Pair it
 * with a `reveal` or `reveal-stagger` class (see index.css) to get the
 * entrance transition; both are no-ops under `prefers-reduced-motion`.
 */
export default function Reveal({
  as: Tag = 'div',
  className = '',
  children,
  threshold,
  rootMargin,
  once,
  ...rest
}) {
  const [ref, inView] = useInView({ threshold, rootMargin, once });
  return (
    <Tag ref={ref} className={`${className}${inView ? ' is-visible' : ''}`} {...rest}>
      {children}
    </Tag>
  );
}
